import { alpha, Checkbox, Chip, ChipProps, Typography } from '@mui/material';
import { ChipPropsColorOverrides } from '@mui/material/Chip/Chip';
import { OverridableStringUnion } from '@mui/types';

interface CheckboxChipProps
    extends Pick<
        ChipProps,
        'ref' | 'label' | 'classes' | 'color' | 'disabled' | 'skipFocusWhenDisabled' | 'sx' | 'variant' | 'component'
    > {
    /** Whether the radio chip is checked */
    checked?: boolean;
    /** The color palette to use for the checked state of the radio chip */
    paletteColor?: OverridableStringUnion<
        'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
        ChipPropsColorOverrides
    >;
}

const CheckboxChip = ({ checked, paletteColor = 'primary', ...props }: CheckboxChipProps) => (
    <Chip
        color="white"
        {...props}
        label={
            <Typography color={checked ? `${paletteColor}.main` : 'sonic-silver.main'} fontSize={16} fontWeight={600}>
                {props.label}
            </Typography>
        }
        icon={<Checkbox className="p-0 pl-1" checked={checked} />}
        sx={{
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: (theme) => (checked ? theme.palette[paletteColor].main : theme.palette['sonic-silver'].main),
            '&:hover': {
                bgcolor: (theme) => alpha(theme.palette.white.contrastText, 0.05),
            },
        }}
    />
);

export { CheckboxChip };
